export const educationData = [
    {
        id: 1,
        institution: 'Govt. Polytechnic, Ambala City',
        course: 'Diploma in ECE',
        startYear: '2010',
        endYear: '2013'
    },
    {
        id: 2,
        institution: 'GNIT, Mullana',
        course: 'Bachelor of Technology(ECE)',
        startYear: '2013',
        endYear: '2017'
    },
    {
        id: 3,
        institution: 'Kurukshetra University',
        course: 'PGDCA',
        startYear: '2017',
        endYear: '2018'
    },
    {
        id: 4,
        institution: 'Masai School',
        course: 'Full-Stack Web Development',
        startYear: '2021',
        endYear: 'Present'
    },
]